
function isValidPhoneNumber(phoneNumber) {
  const phoneRegex = /^[0-9]{10,15}$/;
  return phoneRegex.test(phoneNumber);
}

function isValidFullPhoneNumber(phoneNumber) {
  const phoneRegex = /^\+?[0-9]{10,15}$/;
  return phoneRegex.test(phoneNumber);
}

function isValidOTP(otp) {
  if (!otp) return false;
  const otpRegex = /^[0-9]{6}$/;
  return otpRegex.test(otp);
}

function isValidEmail(email) {
  if (!email) return false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

function isValidString(string) {
  if (!string) return false;
  const stringRegex = /^[a-zA-Z\s]+$/;
  return stringRegex.test(string);
}

function isValidDate(date) {
  if (!date) return false;
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  return dateRegex.test(date);
}

function isDateAdult(date) {
  const today = new Date();
  const birthDate = new Date(date);
  const age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    return age - 1 >= 18;
  }
  return age >= 18;
}

function validateInput(value, validator, errorField, errorMessage) {
  const errorElement = document.querySelector(errorField);

  if(validator == isValidDate) {
    const isAdult = isDateAdult(value)
    if (!isAdult) {
      showError(errorElement, MESSAGES.invalidAge);
      return false;
    }
  }

  if (!validator(value)) {
    showError(errorElement, errorMessage);
    return false;
  }
  hideError(errorElement);
  return true;
}